export default function AppSection() {
  return (
    <section id="app" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="bg-gradient-to-br from-primary-500 via-primary-500 to-accent-500 rounded-2xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 text-center md:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-background-50 mb-4">
              随时随地吃瓜
            </h2>
            <p className="text-sm md:text-base text-background-50/90 leading-relaxed mb-6">
              51黑料吃瓜网全面适配移动端，无需下载任何APP，打开手机浏览器即可畅享高清流畅的黑料在线播放体验。无论你在地铁、午休还是睡前，51吃瓜在线观看随时陪你吃最新鲜的瓜。
            </p>
            <div className="flex flex-wrap items-center justify-center md:justify-start gap-4">
              <div className="flex items-center gap-2 text-background-50/80 text-sm">
                <i className="ri-smartphone-line text-lg"></i>
                <span>手机浏览器直达</span>
              </div>
              <div className="flex items-center gap-2 text-background-50/80 text-sm">
                <i className="ri-wifi-line text-lg"></i>
                <span>无需下载安装</span>
              </div>
              <div className="flex items-center gap-2 text-background-50/80 text-sm">
                <i className="ri-speed-up-line text-lg"></i>
                <span>高清流畅播放</span>
              </div>
            </div>
          </div>
          <div className="w-40 h-40 md:w-48 md:h-48 rounded-2xl bg-background-50/15 backdrop-blur-sm flex items-center justify-center flex-shrink-0">
            <div className="text-center">
              <i className="ri-qr-code-line text-5xl md:text-6xl text-background-50"></i>
              <p className="text-xs text-background-50/70 mt-2">扫码访问</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}